import { resetSecPwd, setSecPwd } from "@/apis/user";
import { LINK_ACCOUNT_TOKEN } from "@/constants";
import { useUserInfoStore } from "@/stores/userInfo";
import { Form, Toast } from "antd-mobile";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

type Values = {
  newSecPassword: string;
  oldSecPassword: string;
  confirmSecPassword: string;
};

export const validateFields = (values: Values, extra?: any) => {
  if (extra.isBindPwd) {
    if (!/^\d{6}$/.test(values.oldSecPassword)) return "请输入正确的旧密码";
  }
  if (!values.newSecPassword) {
    return `请输入${extra.isBindPwd ? "新" : ""}密码`;
  }

  if (extra.isBindPwd && !values.oldSecPassword) {
    return "请输入旧密码";
  }
  if (!values.confirmSecPassword) {
    return `请输入确认${extra.isBindPwd ? "新" : ""}密码`;
  }
  if (!/^\d{6}$/.test(values.newSecPassword)) return "请输入6位数字资金密码";
  if (values.newSecPassword !== values.confirmSecPassword) {
    return "两次输入的密码不一致";
  }
};

export const useSetup = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [userinfo, setUserInfo] = useUserInfoStore()((state) => [
    state.userInfo,
    state.setUserInfo,
  ]);
  const isBindPwd = useMemo(() => {
    return userinfo.secPasswordStatus;
  }, [userinfo.secPasswordStatus]);

  const fetchResetPwd = async (values: Values) => {
    const result = await resetSecPwd(values);
    if (result.ok) {
      Toast.show(result.msg);
      navigate(-1);
    } else {
      Toast.show(result.msg);
    }
  };

  const fetchSetPwd = async (values: Values) => {
    const result = await setSecPwd({
      securePassword: values.newSecPassword,
    });
    if (result.ok) {
      setUserInfo({ secPasswordStatus: true });
      Toast.show(result.msg);
      if(window.localStorage[LINK_ACCOUNT_TOKEN]) {
        navigate('/link_account')
      }
      else {
        navigate(-1);
      }
    } else {
      Toast.show(result.msg);
    }
  };

  return {
    form,
    userinfo,
    isBindPwd,
    fetchResetPwd,
    fetchSetPwd,
  };
};
